export default __webpack_public_path__ + "static/gruppenreisen_europa-b3b12fdbcf6c63f21abeac2e45ade9ad.png";